import type {
  RejectionReasonItem,
  RepPerformanceItem,
  ReviewItem,
  VendorRejectionItem,
} from "./types";

export const repPerformanceData: RepPerformanceItem[] = [
  { id: "rep-1", name: "Ali Khan", target: 50, actual: 40 },
  { id: "rep-2", name: "Sara Ahmed", target: 30, actual: 30 },
  { id: "rep-3", name: "Bilal Noor", target: 60, actual: 42 },
];

export const rejectionReasonData: RejectionReasonItem[] = [
  { id: "reason-1", reason: "Poor Quality", count: 18 },
  { id: "reason-2", reason: "Wrong Price", count: 11 },
  { id: "reason-3", reason: "Late Delivery", count: 9 },
  { id: "reason-4", reason: "Missing Items", count: 7 },
  { id: "reason-5", reason: "Vendor Cancelled", count: 5 },
];

export const vendorRejectionData: VendorRejectionItem[] = [
  {
    id: "vendor-1",
    vendorName: "Fresh Basket",
    rejections: 12,
    topReason: "Poor Quality",
    action: "Warn Vendor",
  },
  {
    id: "vendor-2",
    vendorName: "City Grocers",
    rejections: 6,
    topReason: "Late Delivery",
    action: "Monitor",
  },
  {
    id: "vendor-3",
    vendorName: "Green Valley Mart",
    rejections: 16,
    topReason: "Vendor Cancelled",
    action: "Consider Delisting",
  },
];

export const reviewData: ReviewItem[] = [
  {
    id: "review-1",
    buyerName: "Hina Malik",
    vendorName: "Fresh Basket",
    rating: 5,
    shortComment: "Fresh produce and quick handoff.",
    fullComment:
      "The order arrived on time and the vegetables were fresh. Packaging was simple but clean, and the vendor followed the notes correctly.",
    orderId: "ORD-1048",
  },
  {
    id: "review-2",
    buyerName: "Usman Tariq",
    vendorName: "City Grocers",
    rating: 2,
    shortComment: "Missing items in the bag.",
    fullComment:
      "Two paid items were missing from the order. The delivery was polite, but the vendor did not include tomatoes or lemons and there was no replacement note.",
    orderId: "ORD-1052",
  },
  {
    id: "review-3",
    buyerName: "Mariam Shah",
    vendorName: "Green Valley Mart",
    rating: 1,
    shortComment: "Order cancelled very late.",
    fullComment:
      "The vendor cancelled after the delivery window had almost passed. I had to reorder from another store and lost a lot of time.",
    orderId: "ORD-1059",
  },
  {
    id: "review-4",
    buyerName: "Danish Raza",
    vendorName: "Fresh Basket",
    rating: 4,
    shortComment: "Good quality overall.",
    fullComment:
      "Most items were excellent and the one substitution was reasonable. The order notes could have been checked more carefully.",
    orderId: "ORD-1061",
  },
];
